import { render } from "./MenuNav.vue?vue&type=template&id=5c22d035&scoped=true"
import script from "./MenuNav.vue?vue&type=script&lang=js"
export * from "./MenuNav.vue?vue&type=script&lang=js"

import "./MenuNav.vue?vue&type=style&index=0&id=5c22d035&scoped=true&lang=css"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c22d035"]])

export default __exports__